import React from 'react';
import { productColors } from '../config/colors';

export default function OrderSummary({ formData }) {
  const getTotalItems = () => {
    return formData.orderItems.reduce((total, item) => total + parseInt(item.quantity), 0);
  };

  const ArtworkPreview = ({ artwork, side }) => {
    if (!artwork?.length) return null;
    
    return (
      <div className="relative w-16 h-16 bg-white rounded-md overflow-hidden">
        <img 
          src={artwork[0].preview}
          alt={`${side} artwork`}
          className="w-full h-full object-contain"
        />
        <span className="absolute bottom-0 left-0 right-0 bg-black/50 text-white text-xs px-1 text-center">
          {side}
        </span>
      </div>
    );
  };

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-xl font-semibold text-cyan-500 mb-6">
          Order Summary
        </h2>
        <p className="text-gray-400 mb-8">
          Please review your order details before submitting.
        </p>
      </div>

      <div className="space-y-6">
        <div className="bg-gray-700 p-6 rounded-lg">
          <h3 className="text-lg font-medium text-cyan-500 mb-4">Customer Information</h3>
          <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div>
              <dt className="text-sm text-gray-400">Name</dt>
              <dd className="text-white">{formData.name}</dd>
            </div>
            <div>
              <dt className="text-sm text-gray-400">Email</dt>
              <dd className="text-white">{formData.email}</dd>
            </div>
            {formData.company && (
              <div>
                <dt className="text-sm text-gray-400">Company</dt>
                <dd className="text-white">{formData.company}</dd>
              </div>
            )}
            {formData.phone && (
              <div>
                <dt className="text-sm text-gray-400">Phone</dt>
                <dd className="text-white">{formData.phone}</dd>
              </div>
            )}
          </dl>
        </div>

        <div className="bg-gray-700 p-6 rounded-lg">
          <h3 className="text-lg font-medium text-cyan-500 mb-4">Order Details</h3>
          <p className="text-sm text-gray-400 mb-4">
            Total Items: {getTotalItems()}
          </p>
          <div className="space-y-4">
            {formData.orderItems.map((item) => (
              <div key={item.id} className="flex items-start justify-between border-b border-gray-600 pb-4 last:border-0 last:pb-0">
                <div className="flex items-start space-x-4">
                  <div 
                    className="w-6 h-6 rounded-full border border-gray-600 flex-shrink-0 mt-1"
                    style={{ backgroundColor: item.color }}
                  />
                  <div>
                    <p className="text-white">
                      {item.quantity}x {item.size} {productColors.find(c => c.value === item.color)?.name} {item.type}
                    </p>
                    <div className="mt-2 flex flex-wrap gap-2">
                      {item.type === 'Hats' ? (
                        <ArtworkPreview artwork={item.artwork.front} side="embroidery" />
                      ) : (
                        <>
                          <ArtworkPreview artwork={item.artwork.front} side="front" />
                          <ArtworkPreview artwork={item.artwork.back} side="back" />
                        </>
                      )}
                    </div>
                    {item.notes?.front && (
                      <p className="mt-2 text-sm text-gray-400">
                        <span className="font-medium">Front notes:</span> {item.notes.front}
                      </p>
                    )}
                    {item.notes?.back && (
                      <p className="mt-1 text-sm text-gray-400">
                        <span className="font-medium">Back notes:</span> {item.notes.back}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-gray-700 p-6 rounded-lg">
          <h3 className="text-lg font-medium text-cyan-500 mb-4">Delivery Details</h3>
          {formData.deliveryMethod === 'pickup' ? (
            <div>
              <p className="text-white font-medium">Local Pickup</p>
              <p className="text-gray-300 mt-2">
                Highline Motorsports Group<br />
                768 State Route 50<br />
                Burnt Hills NY 12027
              </p>
              <p className="text-gray-400 mt-2">
                Available Mon-Fri between 9am to 5pm
              </p>
            </div>
          ) : (
            <div>
              <p className="text-white font-medium">Shipping Address</p>
              <p className="text-gray-300 mt-2">
                {formData.shippingAddress.street}<br />
                {formData.shippingAddress.city}, {formData.shippingAddress.state} {formData.shippingAddress.zip}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}